import {all, delay, fork, put, takeLatest} from "redux-saga/effects";
import AlgoliaService from "../../services/AlgoliaService";
import {
  createPartSuccess,
  deletePartSuccess,
  getPartsSuccess,
  getPartSuccess,
  setLoadingInvisible,
  setLoadingVisible,
  updatePartSuccess
} from "../actions";
import {CREATE_PART, DELETE_PART, GET_PART, GET_PARTS, UPDATE_PART} from "../constants/Parts";
import EstService from "../../services/EstService";

export function* getParts() {
  yield takeLatest(GET_PARTS, function* ({ page, perPage, search, filters }) {
    try {
      if (search && page === 1)
        yield delay(1000)
      const res = yield AlgoliaService.getParts({
        query: search,
        hitsPerPage: perPage,
        page: (page - 1),
        filters
      })

      const skip = perPage * (page - 1)
      const from = skip + 1
      const to = (skip + perPage > res.data.nbHits) ? res.data.nbHits : skip + perPage
      yield put(getPartsSuccess(res.data.hits, res.data.nbHits, from, to))
    } catch (err) {
      console.log(err)
    }
  })
}

export function* createPart() {
  yield takeLatest(CREATE_PART, function* ({ data, history }) {
    try {
      //put part numbers into string array
      let part_numbers = []
      for (let i = 1; i <= 5; i++) {
        if (data[`part_number_${i}`]) {
          part_numbers.push(data[`part_number_${i}`])
          delete data[`part_number_${i}`]
        }
      }
      data = {
        ...data,
        part_numbers
      }
      const res = yield EstService.createPart(data)
      yield put(createPartSuccess(res.data))
      history.push(`/app/inventory/${res.data.account_part_id}`)
    } catch (err) {
      console.log(err)
    }
  })
}

export function* updatePart() {
  yield takeLatest(UPDATE_PART, function* ({ id, part, history }) {
    try {
      //put part numbers into string array
      let part_numbers = []
      for (let i = 1; i <= 5; i++) {
        if (part[`part_number_${i}`]) {
          part_numbers.push(part[`part_number_${i}`])
          delete part[`part_number_${i}`]
        }
      }
      part = {
        ...part,
        part_numbers
      }
      const res = yield EstService.updatePart(id, part)
      yield put(updatePartSuccess(res.data))
      history.push(`/app/inventory/${res.data.account_part_id}`)
    } catch (err) {
      console.log('err')
      console.log(err)
    }
  })
}

export function* getPart() {
  yield takeLatest(GET_PART, function* ({ id }) {
    try {
      const res = yield EstService.getPart(id)

      let i = 1;
      res.data.part_numbers.forEach(partNumber => {
        res.data[`part_number_${i}`] = partNumber.sku
        i++
      })

      yield put(getPartSuccess(res.data))
    } catch (err) {
      console.log(err)
    }
  })
}

export function* deletePart() {
  yield takeLatest(DELETE_PART, function* ({ part_id, history }) {
    try {
      yield put(setLoadingVisible());
      yield EstService.deletePart(part_id)

      yield delay(1500)
      yield put(deletePartSuccess())
      yield put(setLoadingInvisible());
      history.push('/app/inventory')
    } catch (err) {
      console.log(err)
      yield put(setLoadingInvisible());
    }
  })
}

export default function* partsSaga() {
  yield all([
    fork(getParts),
    fork(createPart),
    fork(getPart),
    fork(updatePart),
    fork(deletePart),
  ]);
}